export default __webpack_public_path__ + "static/media/icone_mepbay_sem_circulo.7db7e803.png";